import { Autocomplete, AutocompleteProps, Box, TextField, TextFieldProps, createFilterOptions } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

import { Taxonomy } from 'app/model/taxonomy';
import { selectAvailableTaxonomies } from 'features/auth/auth.slice';

type TaxonomySelectorProps = Omit<AutocompleteProps<Taxonomy, true, boolean, false>, 'options' | 'renderInput'> &
    Pick<TextFieldProps, 'autoFocus' | 'variant'>;

export const TaxonomySelector: React.FunctionComponent<TaxonomySelectorProps> = (props) => {
    const available = useSelector(selectAvailableTaxonomies);

    const { autoFocus, variant, ...rest } = props;

    return (
        <Autocomplete
            {...rest}
            multiple
            filterOptions={(options, param) => {
                const filter = createFilterOptions<Taxonomy>();

                return [{ name: 'Select All', id: 'all' }, ...filter(options, param)] as Taxonomy[];
            }}
            options={available}
            getOptionLabel={(tx) => tx.name}
            renderInput={(params) => <TextField {...params} label='Taxonomy' variant={variant} autoFocus={autoFocus} />}
            renderOption={(renderProps, option) => (
                <Box component='li' sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...renderProps}>
                    {/* <img*/}
                    {/*    loading="lazy"*/}
                    {/*    width="20"*/}
                    {/*    src={'https://flagcdn.com/w20/us.png'}*/}
                    {/*    srcSet={'https://flagcdn.com/w40/us.png 2x'}*/}
                    {/*    alt=""*/}
                    {/* />*/}

                    {option.name}
                </Box>
            )}
            disableCloseOnSelect
            isOptionEqualToValue={(option, value) => option.id === value.id}
        />
    );
};
